import NineSlice from "../NineSlice";
import PopUpBlue from "./PopUpBlue";

export default class PopUpRouge extends PopUpBlue {
    constructor(scene, x, y, width, height) {
        super(scene, x, y, width, height);

        this.background.destroy(true);
        this.background = new NineSlice(this.scene, 0, 0, width, height, 'rectangle_ombre_rouge');
        this.add(this.background);
        
        this.Y = - this.background.height / 2 + 15;

    }
}